import PlaybookSegmentationPage from './playbookSegmentationPage.view';

export default PlaybookSegmentationPage;
